export class ProspectsClient {
  constructor(funnel, header) {
    this.funnel = funnel;
    this.header = header;
  }

  // eslint-disable-next-line consistent-return
  async progressStatus(prospectId) {
    try {
      const response = await this.funnel.get(
        `v1.0/prospects/${prospectId}/progress-status`,
        { headers: this.header.base() }
      );
      return response.data.data.attributes;
    } catch (reason) {
      this.progressStatusErrorHandler(reason);
    }
  }

  progressStatusErrorHandler(reason) {
    const { response: { status } = {} } = { ...reason };
    const { response: { data: { errors: [firstError] = [] } = {} } = {} } = { ...reason };
    const { detail } = { ...firstError };

    if (status === '404') {
      throw new Error('Prospecto no encontrado');
    } else if (status === '500') {
      throw new Error(`Error en el servidor. <br />Causa: ${detail}`);
    } else {
      throw new Error(`Error de conexión con en el servidor. <br/>Causa: ${reason.message}`);
    }
  }

  async addInteractionsProspect(prospectId, body) {
    const { data } = await this.funnel.patch(
      `prospects/add-interactions/${prospectId}`, body,
      { headers: this.header.base() }
    );
    return data;
  }
}
